import moment from "moment";
import { stringify } from "qs";

interface PagePoint {
  regKey?: string;
  regAttrs?: string[];
  url?: string | (() => string);
  enable?: boolean;
  consoleLog?: boolean;
  sendPerformanceMsg?: boolean;
  sendErrorMsg?: boolean;
  extData?: object;
  beforeSend?: (target: object, type?: string) => any;
}

const hasRegId = msg => {
  const { regKey } = pagePointConfig;
  const { eventType } = msg;
  if (eventType) {
    // 为自定义事件, 判断有无regkey 或者根据eventType 来判断是否发送
    return msg[regKey] || eventType === "pageLoad" ? true : false;
  } else {
    // dom 元素
    const ownRegId = msg.getAttribute(regKey);
    return ownRegId ? true : false;
  }
};

const options = {
  /**
   * 监听组件标识.
   * @cfg {String} regKey='data-reg-id'
   */
  regKey: "data-reg-id",
  /**
   * 采集组件attr. 可根据配置采集组件Attribute，默认采集所有'data-'开头的attr
   * @cfg {Array} regAttrs=[]
   */
  regAttrs: [],
  /**
   * 埋点数据后台url,可为字符串也可为一个返回url的函数
   * @cfg {string||Function} url=''
   */
  url: "",
  /**
   * 控制台输出,仅在未配置url的情况下
   * @cfg {Boolean} consoleLog=true
   */
  consoleLog: true,
  /**
   * 发送首屏加载数据
   * @cfg {Boolean} sendPerformanceMsg=false
   */
  sendPerformanceMsg: false,
  /**
   * 发送异常错误收集
   * @cfg {Boolean} sendErrorMsg=false
   */
  sendErrorMsg: false,
  /**
   * 用户扩展数据
   * @cfg {Object}
   */
  extData: {},
  /**
   * 埋点发送信息之前调用的方法，可用来判断是否发送此次埋点信息，返回true或者object发送，false反之。
   * 另外支持扩展发送数据和更换事件对象target，返回数据格式{data:xxx,element:xxx}
   * 默认情况下会根据是否包含regKey决定发送与否
   * @cfg {function} 组件数据 参数事件target和事件类型($element,type)
   */
  beforeSend: hasRegId,
  enable: false
};
let perTimeFlag = false;
let pagePointConfig: PagePoint = { ...options };
let clickTimeId,
  browserType = "",
  OSType = "";
const defaultValue = "",
  clickType = "click",
  dblclickType = "dblclick",
  keydownType = "keydown",
  focusType = "focusin",
  EventType = {
    clickType,
    dblclickType,
    keydownType,
    focusType
  };

let defaultAttrs = {
  id: defaultValue,
  tagname: defaultValue,
  className: defaultValue,
  value: defaultValue,
  type: defaultValue,
  name: defaultValue,
  innerText: defaultValue
};

const defaultKeys = {
  shiftKey: false,
  ctrlKey: false,
  altKey: false,
  metaKey: false
};

// 获取浏览器相关的基本数据
const browserData = () => ({
  browser: window.navigator.userAgent,
  url: window.location.href,
  screenWidth: document.body.clientWidth,
  screenHeight: document.body.clientHeight,
  pageTitle: document.title,
  referer: document.referrer,
  evtTime: moment().format("YYYYMMDDHHmmssSSS"),
  browserType,
  OSType
});

const sendPagePoint = (event, ext?) => {
  // 先判断是否埋点已开启
  if (!(pagePointConfig.enable && event)) {
    return;
  }
  let eventData = event,
    composeKeys: any = {};

  const { regKey, extData, beforeSend } = pagePointConfig;

  // 假如 event 为 事件对象, 处理event 信息， 否则直接发送
  if (event.target || event.nativeEvent) {
    const target = event.target || event.currentTarget || event;

    if (target && beforeSend) {
      const result = beforeSend(target, event.type);
      if (!result) {
        return;
      }
      ext = { ...ext, ...result };
    }

    // click 和 keydown 事件 都发送功能按键情况
    if (
      event.eventType === clickType ||
      event.eventType === dblclickType ||
      event.eventType === keydownType
    ) {
      composeKeys = {
        shiftKey: event.shiftKey,
        ctrlKey: event.ctrlKey,
        altKey: event.altKey,
        metaKey: event.metaKey
      };
      // click 情况发送 clientX clientY, kewdown 发送 keyCode
      if (event.eventType !== keydownType) {
        composeKeys.clientX =
          target.clientX +
            window.document.body.scrollLeft +
            window.document.documentElement.scrollLeft || 0;
        composeKeys.clientY =
          target.clientY +
            window.document.body.scrollTop +
            window.document.documentElement.scrollTop || 0;
      } else {
        composeKeys.keyCode = event.keyCode;
      }
    }

    eventData = {
      id: target.id || defaultValue,
      eventType: event.eventType || event.type,
      tagname: target.tagName || defaultValue,
      className: target.className || defaultValue,
      value: target.value || defaultValue,
      type: target.type || defaultValue,
      name: target.name || defaultValue,
      innerText: removeR(target.innerText).substring(0, 50) || defaultValue,
      [regKey]: target.getAttribute(regKey),
      ...composeKeys
    };
  } else {
    // 用户自定义事件,beforeSend送出全部event信息
    let attrs: any = {};
    if (
      event.eventType === clickType ||
      event.eventType === dblclickType ||
      event.eventType === keydownType
    ) {
      attrs = { ...defaultAttrs, ...defaultKeys };
      if (event.eventType !== keydownType) {
        attrs.clientX = 0;
        attrs.clientY = 0;
      } else attrs.keyCode = 0;
    } else if (event.eventType === focusType) {
      attrs = defaultAttrs;
    }

    if (beforeSend) {
      const result = beforeSend(event);
      if (!result) {
        return;
      }
      ext = { ...ext, ...result };
    }

    eventData = { ...attrs, ...eventData };
  }

  // 发送信息组成：event信息 + 浏览器相关信息 + 开启埋点功能时用户配置信息 + 调用sendPagePoint时用户传入信息
  const data = {
    ...eventData,
    ...browserData(),
    ...extData,
    ...ext
  };
  send(data);
};

const logPerformance = () => {
  // 性能相关数据
  const t = window.performance.timing;
  // 如果当前的页面尚未加载完成，那么设个延时等待再次调用
  if (t.loadEventEnd === 0) {
    setTimeout(() => {
      logPerformance();
    }, 2000);
    return;
  }

  const times = {
    eventType: "performanceMsg",
    redirectTime: t.redirectEnd - t.redirectStart, // 重定向时长
    dnsTime: t.domainLookupEnd - t.domainLookupStart, // DNS解析时长
    ttfbTime: t.responseStart - t.navigationStart, // 第一字节读取事件
    appcacheTime: t.domainLookupStart - t.fetchStart,
    unloadTime: t.unloadEventEnd - t.unloadEventStart,
    tcpTime: t.connectEnd - t.connectStart,
    reqTime: t.responseEnd - t.responseStart,
    analysisTime: t.domComplete - t.domInteractive,
    blankTime: t.domLoading - t.fetchStart,
    domReadyTime: t.domContentLoadedEventEnd - t.fetchStart,
    loadTime: t.loadEventEnd - t.navigationStart
  };

  send({ ...times, ...browserData() });
};

const setPagePoint = params => {
  pagePointConfig = { ...pagePointConfig, ...params };
  const { sendPerformanceMsg, sendErrorMsg, enable } = params;
  if (enable !== false) {
    browserType = getBrowserInfo();
    OSType = getOS();
    // 开启web事件监听
    addPagePointEventListener();

    if (sendPerformanceMsg) {
      document.onreadystatechange = function() {
        if (document.readyState === "complete") {
          if (perTimeFlag) return;
          logPerformance();
          perTimeFlag = true;
        }
      };
      setTimeout(() => {
        if (perTimeFlag) return;
        logPerformance();
        perTimeFlag = true;
      }, 2000);
    }
    if (sendErrorMsg) {
      window.onerror = (msg, errurl, line, col = 0, error) => {
        const errordata = {
          eventType: "errorMsg",
          msg,
          url: errurl,
          line,
          col,
          ua: window.navigator.userAgent,
          errorStack: error ? error.stack : "",
          ...browserData()
        };
        send(errordata);
      };
    }
  } else {
    // 关闭事件监听
    removePagePointEventListener();
    window.onerror = () => {};
    perTimeFlag = false;
  }
};

const removeR = str => {
  if (!str) return "";
  try {
    return str.replace(/[\r\n]/g, " ");
  } catch (e) {
    //console.log(e)
  }
};

const send = params => {
  const url = pagePointConfig.url;
  let server_url;
  if (url) {
    if (typeof url === "function") server_url = url();

    const image = new Image(),
      imageID = "pagepoint_" + Date.now();

    image.onload = function() {
      delete window[imageID];
    };

    window[imageID] = image;
    image.src = `${server_url}?${stringify(params)}`;
  } else {
    console.log(params);
  }
};

const clickHandler = (e: any) => {
  const target = e.srcElement ? e.srcElement : e.target;
  const dataUIRole = target.getAttribute("data-ui-role");
  //   console.log('!!!!!!!click',e, target)
  if (dataUIRole) {
    return;
  }
  clearTimeout(clickTimeId);
  clickTimeId = setTimeout(function() {
    e.eventType = clickType;
    sendPagePoint(e);
  }, 300);
};

const dblclickHandler = (e: any) => {
  clearTimeout(clickTimeId);
  const target = e.srcElement ? e.srcElement : e.target;
  const dataUIRole = target.getAttribute("data-ui-role");
  if (dataUIRole) {
    return;
  }
  e.eventType = dblclickType;
  sendPagePoint(e);
};

const keydownHandler = (e: any) => {
  const target = e.srcElement ? e.srcElement : e.target;
  const dataUIRole = target.getAttribute("data-ui-role");
  if (dataUIRole) {
    return;
  }
  e.eventType = keydownType;

  sendPagePoint(e);
};

const focusHandler = (e: any) => {
  try {
    const target = e.srcElement ? e.srcElement : e.target;

    // window 会触发一次
    if (target === window) {
      return;
    }
    const dataUIRole = target.getAttribute("data-ui-role");
    if (dataUIRole) {
      return;
    }

    e.eventType = focusType;
    sendPagePoint(e);
  } catch (e) {}
};

const removePagePointEventListener = () => {
  try {
    if (window.addEventListener) {
      //监听click的事件
      window.removeEventListener("click", clickHandler, true);

      //监听双击dbclick事件
      window.removeEventListener("dblclick", dblclickHandler, true);

      //监听按键事件
      window.removeEventListener("keydown", keydownHandler, true);

      window.removeEventListener("focus", focusHandler, true);
    }
  } catch (e) {}
};

const addPagePointEventListener = () => {
  try {
    if (window.addEventListener) {
      //监听click的事件
      window.addEventListener("click", clickHandler, true);

      //监听双击dbclick事件
      window.addEventListener("dblclick", dblclickHandler, true);

      //监听按键事件
      window.addEventListener("keydown", keydownHandler, true);

      window.addEventListener("focus", focusHandler, true);
    }
  } catch (e) {}
};

//判断所处操作系统
function getOS() {
  const sUserAgent = navigator.userAgent.toLowerCase();

  const isWin =
    navigator.platform === "Win32" ||
    navigator.platform === "Win64" ||
    navigator.platform === "wow64";
  if (isWin) {
    const isWin2K =
      sUserAgent.indexOf("Windows nt 5.0") > -1 ||
      sUserAgent.indexOf("Windows 2000") > -1;
    if (isWin2K) return "Win2000";
    const isWinXP =
      sUserAgent.indexOf("Windows nt 5.1") > -1 ||
      sUserAgent.indexOf("Windows XP") > -1;
    if (isWinXP) return "WinXP";
    const isWin2003 =
      sUserAgent.indexOf("Windows nt 5.2") > -1 ||
      sUserAgent.indexOf("Windows 2003") > -1;
    if (isWin2003) return "Win2003";
    const isWinVista =
      sUserAgent.indexOf("Windows nt 6.0") > -1 ||
      sUserAgent.indexOf("Windows Vista") > -1;
    if (isWinVista) return "WinVista";
    const isWin7 =
      sUserAgent.indexOf("Windows nt 6.1") > -1 ||
      sUserAgent.indexOf("Windows 7") > -1;
    if (isWin7) return "Win7";
    const isWin8 =
      sUserAgent.indexOf("windows nt 6.2") > -1 ||
      sUserAgent.indexOf("Windows 8") > -1;
    if (isWin8) return "Win8";
    const isWin10 =
      sUserAgent.indexOf("windows nt 10.0") > -1 ||
      sUserAgent.indexOf("Windows 10") > -1;
    if (isWin10) return "Win10";
  }

  const isMac =
    navigator.platform === "Mac68K" ||
    navigator.platform === "MacPPC" ||
    navigator.platform === "Macintosh" ||
    navigator.platform === "MacIntel";
  if (isMac) return "Mac";

  const isUnix = navigator.platform === "X11" && !isWin && !isMac;
  if (isUnix) return "Unix";

  const isLinux = String(navigator.platform).indexOf("Linux") > -1;
  const bIsAndroid = sUserAgent.toLowerCase().indexOf("android") > -1;
  if (isLinux) {
    if (bIsAndroid) return "Android";
    else return "Linux";
  }

  return "other";
}

//判断所用浏览器
function getBrowserInfo() {
  const agent = navigator.userAgent.toLowerCase();
  let browserInfo = "";
  // IE
  if (agent.indexOf("trident") > 0) {
    browserInfo = "IE";
  }
  // OLD_IE
  else if (agent.indexOf("msie") > 0) {
    browserInfo = "IE";
  }
  // Edge
  else if (agent.indexOf("edge") > 0) {
    browserInfo = "Edge";
  }
  // firefox
  else if (agent.indexOf("firefox") > 0) {
    browserInfo = "Firefox";
  }
  // Opera
  else if (agent.indexOf("opr") > 0) {
    browserInfo = "Opera";
  }
  // Safari
  else if (agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0) {
    browserInfo = "Safari";
  }
  // Chrome
  else if (agent.indexOf("chrome") > 0) {
    browserInfo = "Chrome";
  } else {
    browserInfo = "other";
  }
  return browserInfo;
}

const extendInfo = data => {
  let extData = pagePointConfig.extData;
  Object.assign(extData, data);
};

export default {
  setPagePoint,
  sendPagePoint,
  pagePointConfig,
  extendInfo,
  EventType
};



// WEBPACK FOOTER //
// ./src/components/page-point/index.tsx